import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import { Router } from 'sv-router';
import '$lib/router';
import Toaster from '$lib/components/ui/toast/Toaster.svelte';
import Footer from '$lib/components/ui/footer/Footer.svelte';

var root = $.from_html(`<main class="min-h-screen bg-background"><div class="max-w-content mx-auto px-4 py-6"><!> <!></div></main> <!>`, 1);

export default function App($$anchor) {
	var fragment = root();
	var main = $.first_child(fragment);
	var div = $.child(main);
	var node = $.child(div);

	Router(node, {});

	var node_1 = $.sibling(node, 2);

	Footer(node_1, {});
	$.reset(div);
	$.reset(main);

	var node_2 = $.sibling(main, 2);

	Toaster(node_2, {});
	$.append($$anchor, fragment);
	// FairNSquare - Root Application Component
	// Router configured in Story 2.3
	// Import router config to initialize routes
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiQXBwLnN2ZWx0ZSJdLCJzb3VyY2VzQ29udGVudCI6WyI8c2NyaXB0IGxhbmc9XCJ0c1wiPlxuICAvLyBGYWlyTlNxdWFyZSAtIFJvb3QgQXBwbGljYXRpb24gQ29tcG9uZW50XG4gIC8vIFJvdXRlciBjb25maWd1cmVkIGluIFN0b3J5IDIuM1xuXG4gIGltcG9ydCB7IFJvdXRlciB9IGZyb20gJ3N2LXJvdXRlcic7XG4gIC8vIEltcG9ydCByb3V0ZXIgY29uZmlnIHRvIGluaXRpYWxpemUgcm91dGVzXG4gIGltcG9ydCAnJGxpYi9yb3V0ZXInO1xuICBpbXBvcnQgVG9hc3RlciBmcm9tICckbGliL2NvbXBvbmVudHMvdWkvdG9hc3QvVG9hc3Rlci5zdmVsdGUnO1xuICBpbXBvcnQgRm9vdGVyIGZyb20gJyRsaWIvY29tcG9uZW50cy91aS9mb290ZXIvRm9vdGVyLnN2ZWx0ZSc7XG48L3NjcmlwdD5cblxuPG1haW4gY2xhc3M9XCJtaW4taC1zY3JlZW4gYmctYmFja2dyb3VuZFwiPlxuICA8ZGl2IGNsYXNzPVwibWF4LXctY29udGVudCBteC1hdXRvIHB4LTQgcHktNlwiPlxuICAgIDxSb3V0ZXIgLz5cbiAgICA8Rm9vdGVyIC8+XG4gIDwvZGl2PlxuPC9tYWluPlxuPFRvYXN0ZXIgLz5cbiJdLCJtYXBwaW5ncyI6Ijs7O1NBSVcsTUFBTSxRQUFRLFdBQVc7T0FFM0IsYUFBYTtPQUNiLE9BQU8sTUFBTSx5Q0FBeUM7T0FDdEQsTUFBTSxNQUFNLHlDQUF5Qzs7OztzQ0FSOUQsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBU0YsQ0FBQyJ9